// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_cz6","cls2":"ToolsMenu-cls2__Ho ToolsMenu-cls1_cz6"};